module.exports = __webpack_public_path__ + "static/media/unsplashImage.8dd53ba0.png";